import styled from '@emotion/styled';
import { Divider } from '@mui/material';

const SettingsDivider = styled(Divider)({
  margin: '18px -16px',
});

export default SettingsDivider;
